import { removeNulls } from 'utils/Object.utils';

import propertyLoansReducer, {
  type PropertyLoansState,
} from './portfolio.propertyLoans.reducer';
import propertyOwnershipReducer, {
  type PropertyOwnershipState,
} from './portfolio.propertyOwnership.reducer';
import propertyDepreciationReducer, {
  type PropertyDepreciationState,
} from './portfolio.propertyDepreciation.reducer';

type ReducerAction = {
  type?: string;
  [key: string]: any;
};

export type Property = {
  id?: string;
  loans?: PropertyLoansState;
  ownership?: PropertyOwnershipState;
  depreciation?: PropertyDepreciationState;
  [key: string]: any;
};

export type PropertiesState = Record<string, any>;

const initialState: PropertiesState = {};

const propertiesReducer = (
  state: PropertiesState = initialState,
  action: ReducerAction
): PropertiesState => {
  switch (action.type) {
    case 'PROPERTY_ADD_NEW': {
      const { property } = action;
      return {
        ...state,
        [property.id]: property,
      };
    }
    case 'PROPERTY_UPDATE': {
      const { property } = action;
      return {
        ...state,
        [property.id]: property,
      };
    }
    case 'PROPERTY_DELETE': {
      const { propertyId } = action;
      return removeNulls({
        ...state,
        [propertyId]: null,
      }) as PropertiesState;
    }
    default: {
      const { propertyId } = action;
      const property = state[propertyId];
      if (property) {
        return {
          ...state,
          [propertyId]: {
            ...property,
            loans: propertyLoansReducer(property.loans, action),
            ownership: propertyOwnershipReducer(property.ownership, action),
            depreciation: propertyDepreciationReducer(
              property.depreciation,
              action
            ),
          },
        };
      }
      return state;
    }
  }
};
export default propertiesReducer;
